module.exports = __webpack_public_path__ + "media/photo/Group 327@2x-5cea9f0d.jpg";